module.exports = __webpack_public_path__ + "static/media/card-logo-mastercard.e4601009.svg";